/*
 * Copyright (c) 2026 Talent Catalog.
 *
 * This program is free software: you can redistribute it and/or modify it under
 * the terms of the GNU General Public License as published by the Free
 * Software Foundation, either version 3 of the License, or any later version.
 *
 * This program is distributed in the hope that it will be useful, but WITHOUT
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or
 * FITNESS FOR A PARTICULAR PURPOSE. See the GNU General Public License
 * for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program. If not, see https://www.gnu.org/licenses/.
 */

import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {StatReport} from "../model/stat-report";
import {Stat} from "../model/stat";

export interface CandidateStatsRequest {
  listId?: number;
  searchId?: number;
  dateFrom?: string;
  dateTo?: string;
  selectedStats?: Stat[];
}

@Injectable({providedIn: 'root'})
export class CandidateStatService {

  private apiUrl = environment.apiUrl + '/candidate/stat';

  constructor(private http: HttpClient) {}

  getAllStats(details: CandidateStatsRequest): Observable<StatReport[]> {
    return this.http.post<StatReport[]>(`${this.apiUrl}/all`, details);
  }

}
